import { findIndex } from "lodash";
import { StepConfig } from "../hearing-aids-wizard.type";

export const getSiblingStep = (
  stepsConfig: StepConfig[],
  currentStep: StepConfig | undefined,
  direction: 1 | -1
) => {
  if (!currentStep) return undefined;

  const curStepIndex = findIndex(
    stepsConfig,
    (step) => step.id === currentStep.id
  );

  if (currentStep.parentId) {
    const parentStep = stepsConfig.find(
      (step) => step.id === currentStep.parentId
    );

    const curSubStepIndex = findIndex(
      parentStep?.substeps,
      (id) => id === currentStep.id
    );

    const subStepId = parentStep?.substeps[curSubStepIndex + direction];

    if (subStepId) {
      return stepsConfig.find((step) => step.id === subStepId);
    }
  }

  let stepIndex = findIndex(
    stepsConfig,
    (step, index) =>
      (direction === 1 ? index > curStepIndex : index < curStepIndex) &&
      !step.parentId
  );

  if (stepIndex === -1) return undefined;

  if (
    !stepsConfig[stepIndex].substeps.length &&
    stepsConfig.find((step) => step.parentId === stepsConfig[stepIndex].id)
  ) {
    stepIndex = findIndex(
      stepsConfig,
      (step, index) =>
        (direction === 1 ? index > stepIndex : index < stepIndex) &&
        Boolean(step.parentId)
    );
  }
  return stepsConfig[stepIndex];
};
